import localeHu from './locales/hu';

export default {
    hu: localeHu,
};



// WEBPACK FOOTER //
// ./src/i18n/index.ts